import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { NICmsContentField } from '@icms/core/content';
import { IconsOptions } from '../../../styles/cms.config';
import { NAntavo } from '../../antavo/antavo.interface';

/**
 * Interface for the mission success content
 */
export interface IMissionSuccessContent {
    successUserIcon: string;
    successTitle: string;
    successButtonText: string;
    accountButtonText: string;
}

export const MISSION_SUCCESS_FIELDS: NICmsContentField.IField[] = [
    <NICmsContentField.IChoiceField>{
        key: 'successUserIcon',
        title: 'Success User Icon',
        type: NICmsContentField.EFieldType.choice,
        options: IconsOptions,
        previewMode: 'icon',
        default: 'icon-mission'
    },
    {
        type: NICmsContentField.EFieldType.text,
        key: 'successTitle',
        title: 'Success Title',
        default: 'Congratulations! You completed your first mission',
        required: true
    },
    {
        type: NICmsContentField.EFieldType.text,
        key: 'successButtonText',
        title: 'Success Button Text',
        default: 'Shop LeMieux',
        required: true
    },
    {
        type: NICmsContentField.EFieldType.text,
        key: 'accountButtonText',
        title: 'Account Button Text',
        default: 'Go To My Account',
        required: true
    }
];

/**
 * Component for displaying mission success information
 */
@Component({
    selector: 'mission-success',
    templateUrl: './mission-success.component.html',
    styleUrls: ['./mission-success.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule, ICmsClientModule, RouterModule]
})
export class MissionSuccessComponent extends UiComponent {
    /**
     * Mission data from Antavo
     */
    @Input({ required: true })
    mission!: NAntavo.IChallenge;

    /**
     * CMS content for the success view
     */
    @Input({ required: true })
    content!: IMissionSuccessContent;
}
